import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
  BLOCK_RECENT_PROFESSIONAL,
  FETCH_RECOMMENDED_PROFESSIONALS_ACTION,
  fetchRecommendedProfessionals,
} from '~/actions';
import { getShouldShowRecommendedPros } from '~/growthbook';
import { useAppSelector } from '~/hooks/useAppSelector';
import useLoading from '~/hooks/useLoading';

const actions = [FETCH_RECOMMENDED_PROFESSIONALS_ACTION, BLOCK_RECENT_PROFESSIONAL];

export const useRecommendedProsList = () => {
  const isInitialized = useRef(false);
  const isRecommendedProsEnabled = useRef(getShouldShowRecommendedPros());
  const dispatch = useDispatch();
  const { isLoading } = useLoading(actions);
  const { recommendedProfessionals, professionalHubFilter: filter } = useAppSelector(
    (state) => state.user,
  );

  const fetchRecommendedPros = useCallback(async () => {
    if (isRecommendedProsEnabled.current) {
      await dispatch(fetchRecommendedProfessionals({ filter }));
    }

    isInitialized.current = true;
  }, [dispatch, filter]);

  return {
    isInitialized: isInitialized.current,
    recommendedProfessionals,
    isLoading: isLoading,
    isEmpty: !recommendedProfessionals?.length,
    isFiltered: filter !== 'all',
    filter: filter !== 'all' ? filter : undefined,
    fetchRecommendedPros,
    isRecommendedProsEnabled: isRecommendedProsEnabled.current,
  };
};
